import { createAction } from '@reduxjs/toolkit';

export default createAction('adjustOrder', ({ saleType, locationId }) => ({
  payload: {
    saleType,
    locationId,
  },
}));
